import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../utils/api";
import { Line, Bar } from "react-chartjs-2";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import ReactTooltip from 'react-tooltip';
import { format} from 'date-fns';

import MarketingChannel from '../components/performance/MarketingChannel';
import useFeatureGates from "../hooks/useFeatureGates";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

import DateRangeDropdown from "../components/performance/Filter";
import dollarIcon from '../../../assets/images/performance/doller-icon.svg';
import personIcon from '../../../assets/images/performance/person-star.svg';
import checkIcon from '../../../assets/images/performance/eye-check.svg';
import chartIcon from '../../../assets/images/performance/chart.svg'
import ImpactCard from "../components/performance/ImpactCard";
import Loader from "../components/Loader";


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const PerformancePage = () => {
  const chartRefs = {
    sales: useRef(null),
    visitors: useRef(null),
    views: useRef(null),
    hours: useRef(null),
    campaigns: useRef(null)
  };

  const [accuratePerformanceSummaryData, setAccuratePerformanceSummaryData] = useState([])
  const [accuratePerformanceEventsData, setAccuratePerformanceEventsData] = useState([])

  const [activeTab, setActiveTab] = useState("visitors");
  const [dateRange, setDateRange] = useState({range: "12_months"});
  const [tabValues, setTabValues ] = useState({
    sales: null,
    visitors: null,
    views: null,
    hours: null,
    campaigns: null
  });

  const [tabPercentage, setTabPercentage] = useState({
    sales: null,
    visitors: null,
    views: null,
    hours: null,
    campaigns: null
  });

  const defaultCampaignStats = {
    total: 0,
    percentage_change: 0
  };

  const defaultRoiStats = {
    total: 0,
    percentage_change: 0
  };

  const { companySlug } = useParams();
  const { featureGates } = useFeatureGates('company');
  const hasAttendeeValueEstimator = featureGates.includes('true-attendee-value-estimator');
  const performanceSummaryDataStatic = {
    visitors: {
      labels: [
        "May 2024", "Jun 2024", "Jul 2024", "Aug 2024", "Sep 2024", "Oct 2024",
        "Nov 2024", "Dec 2024", "Jan 2025", "Feb 2025", "Mar 2025", "Apr 2025", "May 2025"
      ],
      values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0],
      total: 2,
      percentage: 20
    },
    sales: {
      labels: [
        "May 2024", "Jun 2024", "Jul 2024", "Aug 2024", "Sep 2024", "Oct 2024",
        "Nov 2024", "Dec 2024", "Jan 2025", "Feb 2025", "Mar 2025", "Apr 2025", "May 2025"
      ],
      values: [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 33, 29],
      total: 5,
      percentage: 10
    },
    views: {
      labels: [
        "May 2024", "Jun 2024", "Jul 2024", "Aug 2024", "Sep 2024", "Oct 2024",
        "Nov 2024", "Dec 2024", "Jan 2025", "Feb 2025", "Mar 2025", "Apr 2025", "May 2025"
      ],
      values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 0],
      total: 5,
      percentage: 10
    },
    hours: {
      labels: [
        "May 2024", "Jun 2024", "Jul 2024", "Aug 2024", "Sep 2024", "Oct 2024",
        "Nov 2024", "Dec 2024", "Jan 2025", "Feb 2025", "Mar 2025", "Apr 2025", "May 2025"
      ],
      values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
      total: 1,
      percentage: 10
    },
    campaigns: {
      labels: [
        "May 2024", "Jun 2024", "Jul 2024", "Aug 2024", "Sep 2024", "Oct 2024",
        "Nov 2024", "Dec 2024", "Jan 2025", "Feb 2025", "Mar 2025", "Apr 2025", "May 2025"
      ],
      values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
      total: 1,
      percentage: 10
    }

  };

  const staticEventData = {
    cumulative_visitors: {
      total: 0,
      previous_period_total: 0,
      percentage_change: null
    },
    event_calendars: [],
    events: [
      {
        id: 1353,
        name: "test wrong  times not in past",
        address: {
          zip: "68102",
          city: "Omaha",
          state: "Nebraska",
          street: "808 Conagra Drive, suite 401"
        },
        city_state: "Omaha, Nebraska",
        start_date: "2020-02-01",
        published: true,
        banner_image_url: "/assets/defaults/banner-7c0534fe5aabed6369040e4894355e32f1a4c67ecbb483a478f59119df123ddb.jpg",
        banner_image_mobile_url: null,
        ticket_page_visits: "2",
        estimated_sales: "5.0",
        estimated_views: "0",
        estimated_roi: 0.05
      },
      {
        id: 1833,
        name: "Cinco De Mayo Taco Tuesday",
        address: {
          zip: "68372",
          city: "Hickman",
          state: "NE",
          street: "6740 Woodland Blvd"
        },
        city_state: "Hickman, NE",
        start_date: "2024-10-08",
        published: true,
        banner_image_url: "https://ucarecdn.com/c132e6bf-7c2f-4ff6-9788-d9ebe3845b7d/-/crop/624x312/98,0/-/preview/-/format/auto/",
        banner_image_mobile_url: null,
        ticket_page_visits: "2",
        estimated_sales: "5.0",
        estimated_views: "0",
        estimated_roi: 0.05
      },
      {
        id: 3377,
        name: "test picture",
        address: null,
        city_state: null,
        start_date: "2024-07-19",
        published: true,
        banner_image_url: "https://ucarecdn.com/df9c12dc-fd24-48c1-9e07-b229470cd34e/-/format/auto/",
        banner_image_mobile_url: null,
        ticket_page_visits: "2",
        estimated_sales: "5.0",
        estimated_views: "5",
        estimated_roi: 0.05
      }
    ],
    total_pages: 32,
    current_page: 1
  };

  const [chartData, setChartData] = useState({
    sales: { labels: [], datasets: [] },
    visitors: { labels: [], datasets: [] },
    views: { labels: [], datasets: [] },
    hours: { labels: [], datasets: [] },
    campaigns: { labels: [], datasets: [] },
  });


  const EventTabHeader = [
      {
        label: "Event Details",
        tooltip:  'Event Details',
        id: 'event_details'
      },
      {
        label: "Estimated ROI",
        tooltip: "An estimate of your return on investment, calculated by adding your estimated ticket sales revenue to the estimated value of the hours Vesta saved you (at $15/hour), then dividing by your total marketing spend with Vesta during the selected period.",
        id: "event_roi-tip",
      },
      {
        label: "Estimated Sales",
        tooltip: " This metric estimates the number of ticket sales generated by your events. It's calculated using the number of visitors Vesta has driven to your ticket pages, your events’ ticket prices, and benchmark conversion rates from thousands of similar events promoted through Vesta",
        id: "event_sales-tip",
      },
      {
        label: "Ticket Page Visitors",
        tooltip: "This number shows exactly how many times someone clicked through to your ticketing page after discovering your event on one of Vesta’s marketing channels. Vesta uses unique tracking links in all event promotions to accurately measure each click.",
        id: "event_visitors-tip",
      },
      {
        label: "Estimated Views",
        tooltip: "This metric provides an approximate measure of the total exposure your events receive through Vesta’s marketing. It combines actual impression data from certain marketing channels with estimated impressions from others to give you a sense of overall visibility.",
        id: "event_views-tip",
      },
      {
        label: "Marketing",
        tooltip: "Boost.",
        id: "event_marketing-tip",
      },
    ];

  const roisInfo = [
    {
      id: 'roi',
      title: "Lifetime Return on Investment",
      tooltip: "An estimate of your return on investment since onboarding with Vesta. This metric only includes events that have already occurred—ROI data for upcoming events will appear once the event concludes. We calculate ROI by: Adding estimated ticket sales revenue, plusThe monetary value of time saved by using Vesta (calculated at $15/hour)Then dividing this sum by your total marketing spend on those completed events",
      accentColor: '#633AFB',
    },
    {
      id: 'roi_ads',
      title: "Lifetime Return on Ad Spend",
      tooltip: "An estimate of your return on ad spend since onboarding with Vesta. This metric only includes events that have already occurred—ROAS data for upcoming events will appear once the event concludes. We calculate ROAS by: Dividing estimated ticket sales revenue by your total marketing spend on those completed events",
      accentColor: '#CD03FD',
    }
  ]
  const { data: performanceSummaryData, error: summaryRequestError, isLoading: isSummaryLoading, isFetching: isSummaryFetching } = useQuery({
    // The summary API returns every metric at once and the request never sends the
    // selected tab, so the key must not include it: a tab-keyed query refetches the
    // identical data and flashes the full-page <Loader/> on every tab click.
    queryKey: ["performanceSummary", dateRange],
    queryFn: () => {
      const params = new URLSearchParams();
      params.append('range', dateRange.range);
      params.append('slug', companySlug);

      if (dateRange.range === "custom") {
        params.append('start_date', dateRange.start_date);
        params.append('end_date', dateRange.end_date);
      }

      return fetchData(`api/a/summary?${params.toString()}`);
    },
  });

  const { data: performanceEventsData, error: eventsRequestError, isLoading: isEventsLoading, isFetching: isEventsFetching } = useQuery({
    queryKey: ["performanceEvents"],
    queryFn: () => fetchData(`api/a/events?page=1&per_page=10&performance_view=true`),
  });


  useEffect(()=> {
    if (summaryRequestError) {
      // The request failed: never present the demo dataset as the customer's real
      // numbers. Blank everything out (tabs render "--") and let the
      // performance__error banner explain.
      const emptyChartData = {};
      const emptyTabValues = {};
      const emptyTabPercentage = {};

      ["sales", "visitors", "views", "hours", "campaigns"].forEach(tab => {
        emptyChartData[tab] = { labels: [], datasets: [] };
        emptyTabValues[tab] = null;
        emptyTabPercentage[tab] = null;
      });

      setChartData(emptyChartData);
      setTabValues(emptyTabValues);
      setTabPercentage(emptyTabPercentage);
      setAccuratePerformanceSummaryData(null)
    } else if(!performanceSummaryData || performanceSummaryData?.length === 0) {

      if (performanceSummaryDataStatic) {
        const newChartData = {};
        const newTabValues = {};
        const newTabPercentage = {};

        ["sales", "visitors", "views", "hours", "campaigns"].forEach(tab => {
          newChartData[tab] = createChartConfig(tab, performanceSummaryDataStatic);
          newTabValues[tab] = performanceSummaryDataStatic[tab]?.total
          newTabPercentage[tab] = performanceSummaryDataStatic[tab]?.percentage
        });

        setChartData(newChartData);
        setTabValues(newTabValues);
        setTabPercentage(newTabPercentage);

        ["sales", "visitors", "views", "hours", "campaigns"].forEach(tab => {
          if (chartRefs[tab].current) {
            setTimeout(() => applyGradient(chartRefs[tab], tab), 100);
          }
        });
      }
      setAccuratePerformanceSummaryData(performanceSummaryDataStatic)
    } else {
      if (performanceSummaryData) {
        const newChartData = {};
        const newTabValues = {};
        const newTabPercentage = {};

        ["sales", "visitors", "views", "hours", "campaigns"].forEach(tab => {
          newChartData[tab] = createChartConfig(tab, performanceSummaryData);
          newTabValues[tab] = performanceSummaryData[tab]?.total || 0;
          newTabPercentage[tab] =  performanceSummaryData[tab]?.percentage || 0;
        });

        setChartData(newChartData);
        setTabValues(newTabValues);
        setTabPercentage(newTabPercentage);

        ["sales", "visitors", "views", "hours", "campaigns"].forEach(tab => {
          if (chartRefs[tab].current) {
            setTimeout(() => applyGradient(chartRefs[tab], tab), 100);
          }
        });
      }

      console.log(performanceSummaryData);

      setAccuratePerformanceSummaryData(performanceSummaryData)
    }
  }, [performanceSummaryData, summaryRequestError])

  useEffect(()=> {
    if (eventsRequestError) {
      // same rule as the summary: a failed request must not show demo events
      setAccuratePerformanceEventsData(null)
    } else if (!performanceEventsData || performanceEventsData?.length === 0) {
      setAccuratePerformanceEventsData(staticEventData)
    } else {
      setAccuratePerformanceEventsData(performanceEventsData)
    }
  }, [performanceEventsData, eventsRequestError])


  if(summaryRequestError && eventsRequestError) {
    toast.error('Something went wrong. Please try again later!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    window.location.href = '/'
  }

  const createChartConfig = (tab, data) => {
    const configs = {
      sales: {
        label: "Estimated Sales",
        borderColor: "#633AFB",
        backgroundColor: "rgba(99, 58, 251, 1)",
        fill: { target: 'origin', above: "rgba(99, 58, 251, 1)" },
        tension: 0.4
      },
      visitors: {
        label: "Ticket Page Visitors",
        borderColor: "#633AFB",
        backgroundColor: "rgba(99, 58, 251, 1)",
        fill: { target: 'origin', above: "rgba(99, 58, 251, 1)" },
        tension: 0.4
      },
      views: {
        label: "Estimated Views",
        borderColor: "#633AFB",
        backgroundColor: "rgba(99, 58, 251, 1)",
        fill: { target: 'origin', above: "rgba(99, 58, 251, 1)" },
        tension: 0.4
      },
      hours: {
        label: "Hours Saved",
        borderColor: "#633AFB",
        backgroundColor: "rgba(99, 58, 251, 1)",
        fill: { target: 'origin', above: "rgba(99, 58, 251, 1)" },
        tension: 0.4
      },
      campaigns: {
        label: "Active Campaigns",
        borderColor: "#633AFB",
        backgroundColor: "rgba(99, 58, 251, 1)",
        fill: { target: 'origin', above: "rgba(99, 58, 251, 1)" },
        tension: 0.4
      }
    };

    const tabData = data[tab] || { labels: [], values: [] };

    return {
      labels: tabData.labels,
      datasets: [{
        label: configs[tab].label,
        data: tabData.values,
        borderWidth: 2,
        pointRadius: 0,
        pointHoverRadius: 6,
        pointHitRadius: 10,
        ...configs[tab]
      }]
    };
  };

  const applyGradient = (chartRef, tab) => {
    const canvas = chartRef?.current;
    if (!canvas || !canvas.ctx || !chartData[tab]) return;

    const ctx = canvas.ctx;
    const height = canvas.height || 300; // fallback height

    const gradient = ctx.createLinearGradient(0, 0, 0, height);
    gradient.addColorStop(0, "rgba(99, 58, 251, 1)");
    gradient.addColorStop(1, "rgba(255, 255, 255, 1)");

    setChartData(prev => ({
      ...prev,
      [tab]: {
        ...prev[tab],
        datasets: [{
          ...prev[tab].datasets[0],
          backgroundColor: gradient,
          fill: {
            target: 'origin',
            above: gradient
          }
        }]
      }
    }));
  };

  const formatSalesNumber = (v) => {
    const n = typeof v === "number" ? v : parseFloat(v);
    return Number.isFinite(n)
      ? n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : "0.00";
  };

  const chartOptions = (tab) => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        labels: {
          font: {
            family: "'Manrope', sans-serif",
          }
        }
      },
      tooltip: {
        enabled: true,
        mode: 'index',
        intersect: false,
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || '';
            const value = context.parsed.y ?? '';
            if (tab === 'sales') {
              return `${label}: $${formatSalesNumber(value)}`;
            } else {
              return `${label}: ${value.toLocaleString('en-US')}`;
            }
          }
        }
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: '#666' }
      },
      y: {
        grid: {
          display: true,
          color: 'rgba(0, 0, 0, 0.05)'
        },
        ticks: {
          color: "#666",
          beginAtZero: true
        }
      },
    },
    interaction: {
      mode: 'index',
      intersect: false
    },
    elements: {
      point: {
        radius: 0,
        hoverRadius: 6,
        hoverBorderWidth: 2
      }
    }
  });

  const handleDateRangeChange = ({ range, adjustedStartDate, adjustedEndDate }) => {
    const isCustom = range === "custom";
    setDateRange(
      isCustom
        ? {
            range,
            start_date: format(adjustedStartDate, 'yyyy-MM-dd'),
            end_date: format(adjustedEndDate, 'yyyy-MM-dd'),
          }
        : { range }
    );
  };

  if ((isSummaryLoading || isSummaryFetching) || (isEventsLoading || isEventsFetching)) return <Loader />;

  return (
    <div className="performance cts-container">
      <div className="performance__heading mb-4">
        <h2>Impact Summary</h2>
        <DateRangeDropdown
          onRangeChange={handleDateRangeChange}
          selectedRange={dateRange}
        />
      </div>

      <div className="performance__card_container">
        {summaryRequestError && <div className="performance__error">{summaryRequestError?.response?.data?.error || 'Cannot fetch summary'}</div>}
        <div className="card left-card">
          <nav>

            <div className="nav nav-tabs" id="impact-summary" role="tablist">
              {["visitors", "sales", "views", "hours", "campaigns"].map(tab => (
                <TabHeader
                  key={tab}
                  tab={tab}
                  activeTab={activeTab}
                  onClick={() => setActiveTab(tab)}
                  value={tabValues[tab]}
                  percentage={tabPercentage[tab]}
                />
               ))}
            </div>
          </nav>

          <div className="tab-content p-4" id="nav-tabContent">
            {["sales", "views"].map(tab => (
              <div
                key={tab}
                className={`tab-pane fade ${activeTab === tab ? "show active" : ""}`}
                id={`nav-${tab}`}
              >
                <div style={{ height: "300px" }}>
                  <Line
                    ref={chartRefs[tab]}
                    data={chartData[tab]}
                    options={chartOptions(tab)}
                  />
                </div>
              </div>
            ))}

            {["visitors", "hours", "campaigns"].map(tab => (
              <div
                key={tab}
                className={`tab-pane fade ${activeTab === tab ? "show active" : ""}`}
                id={`nav-${tab}`}
              >
                <div style={{ height: "300px" }}>
                  <Line
                    ref={chartRefs[tab]}
                    data={chartData[tab]}
                    options={chartOptions(tab)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* <SideStats live_campaigns={accuratePerformanceSummaryData?.live_campaigns || defaultCampaignStats} roi={accuratePerformanceSummaryData?.roi || defaultRoiStats}/> */}
      </div>

      <div>
        <hr className="mb-4 mt-0"/>
        <h2 className="mb-4 life-time-heading">Lifetime Impact</h2>
        <div className="row">
          {roisInfo.map((roiItem, index) => (
            <ImpactCard
              key={index}
              title={roiItem.title}
              roi={ roiItem.id === 'roi' ? (accuratePerformanceSummaryData?.roi || 0) : (accuratePerformanceSummaryData?.roas || 0)}
              tooltip={roiItem.tooltip}
              accentColor={roiItem.accentColor}
            />
          ))}
        </div>

        {/* <MarketingChannel /> */}

        <hr className="mt-40 mb-4"/>
        <div className="performance__heading mb-4">
          <h2>Events and Publicity</h2>
        </div>

        {accuratePerformanceEventsData?.events?.length > 0 ? (
          <div className="card event_card">
            {eventsRequestError && <div className="performance__error">{eventsRequestError?.response?.data?.error || "Cannot fetch events."}</div>}
            <div className="event_card__heading">
              <h4>Events</h4>
              <Link to={`/companies/${companySlug}/events`}>
                View All <i className="fa-solid fa-arrow-right" style={{ color: 'inherit' }}></i>
              </Link>
            </div>
            <div className="table-responsive">
              <table className="table bg-white">
              <thead className="table-header-bold">
              <tr>
                {EventTabHeader.map(({ label, tooltip, id }) => (
                  <th
                    key={id}
                    className="border-0 events-th events-header-th"
                    {...(label !== "Event Details" && label !== "Marketing" && {
                      "data-tip": tooltip,
                      "data-for": id,
                    })}
                  >
                    {label}
                    {label !== "Event Details" && label !== "Marketing" && <CustomTooltip id={id} />}
                  </th>
                ))}
              </tr>
              </thead>
                <tbody className="table-data">
                  {accuratePerformanceEventsData.events.map((item, index) => (
                    <tr key={index}>
                      <td className="border-top p-2">
                        {/* Image */}
                        <a
                          href={`/events/${item.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none text-dark"
                        >
                          <div className="d-flex align-items-center between-gap w-max-content">
                            <img src={item.banner_image_url} alt="event" className="img-thumbnail p-0"
                            />
                            <div className="heading-container">
                              <div className="events-title d-inline-flex">
                                <div className="event-title-text">
                                  <i className="fa fa-external-link mr-2 font_size-10 m-bottom-3" aria-hidden="true"></i>
                                  {item.name}
                                </div>
                              </div>
                              <div className="events-sub-title d-flex align-items-center">
                                {item.city_state}
                                <span className="mx-1">|</span>
                                <span>
                                  {new Intl.DateTimeFormat("en-US", {
                                    month: "long",
                                    day: "numeric",
                                    year: "numeric",
                                  }).format(new Date(item.start_date))}
                                </span>
                              </div>
                            </div>
                          </div>
                        </a>
                      </td>
                      <td className="border-top events-tr" data-for={`event-roi-{item.id}`} data-tip="ROI isn't displayed until the day an event ends">
                        {item.is_upcoming && (
                          <CustomTooltip id={`event-roi-{item.id}`}></CustomTooltip>
                        )}
                        <img src={chartIcon} className="pr-1" alt="chart icon" />
                        {typeof item.estimated_roi === 'number' ? item.estimated_roi.toLocaleString('en-US') + 'x' : item.estimated_roi}
                        <Link
                          to={`/events/${item.id}/analytics`}
                          className="ml-2 text-primary"
                          title="View detailed analytics"
                        >
                          <i className="fa fa-chart-bar" style={{ fontSize: "0.85rem" }}></i>
                        </Link>
                      </td>
                      <td className="border-top events-tr">
                        <img src={dollarIcon} className="pr-1" alt="event" />
                        {item.estimated_sales}
                      </td>
                      <td className="border-top events-tr">
                        <img src={personIcon} className="pr-1" alt="event" />
                        {item.ticket_page_visits}
                      </td>
                      <td className="border-top events-tr">
                        <img src={checkIcon} className="pr-1" alt="event" />
                        {item.estimated_views}
                      </td>
                      <td className="border-top events-tr primary-blue">
                        {item.is_upcoming ? (
                          <Link to={`/marketing?event_id=${item.id}`} className="boost-btn primary-blue bg-white border-primary-blue">
                            Boost!
                            <i className="fa fa-arrow-right primary-blue border-primary-blue"></i>
                          </Link>
                        ) : (
                          <span className="text-muted">Boosting unavailable</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : eventsRequestError ? (
          <div className="performance__error">{eventsRequestError?.response?.data?.error || "Cannot fetch events."}</div>
        ) : (
          <p className="text-center mt-3">There are no events present to show here</p>
        )}
      </div>
    </div>
  )
};

const CustomTooltip = ({ id }) => (
  <ReactTooltip
    id={id}
    place="bottom"
    effect="solid"
    className="tooltip-lg"
  />
);

const TabHeader = ({ tab, activeTab, onClick, value, percentage }) => {
  const tabInfo = {
    sales: { title: "Estimated Sales", isCurrency: true,  tooltip: "This is an estimate of the number of sales your events have generated based on the number of visitors Vesta has driven to your ticket pages, your events’ ticket prices, and conversion rate data that we’ve compiled from thousands of other events promoted by Vesta" },
    visitors: { title: "Ticket Page Visitors", isCurrency: false, tooltip: 'This is the exact number of times someone has found your event through one of Vesta’s marketing channels, and clicked through to your ticketing page. Vesta uses tracking links on all of the promotions we run for your events to accurately measure this.'},
    views: { title: "Estimated Views", isCurrency: false, tooltip: 'This is an estimate derived from real impression data that Vesta receives from some marketing sources, and estimated impression data obtained from other sources. This metric is meant to give you a ballpark estimate of the total exposure that Vesta’s marketing is generating for your events' },
    hours: { title: "Hours Saved", isCurrency: false, tooltip: "The estimated number of hours you've saved by having Vesta automate marketing tasks during the selected time period." },
    campaigns: { title: "Active Campaigns", isCurrency: false, tooltip: "This number shows how many of your events had marketing campaigns running during the selected range." }
  };

  const { title, isCurrency, tooltip } = tabInfo[tab];
  return (
    <a
      className={`nav-item nav-link ${activeTab === tab ? "active" : ""}`}
      id={`nav-${tab}-tab`}
      data-toggle="tab"
      href={`#nav-${tab}`}
      role="tab"
      onClick={(e) => { e.preventDefault(); onClick(); }}
    >
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h3>{title}</h3>
        <InfoIcon tooltip={tooltip} tipId={tab} />
      </div>
      <div className="d-flex justify-content-start align-items-center">
      <h3>
        {value != null ? (
          <>
            {isCurrency && '$'}
            {typeof value === 'number'
              ? new Intl.NumberFormat().format(value)
              : value}
          </>
        ) : (
          "--"
        )}
      </h3>
        <PercentageBadge percentage={percentage} title = {title} />
      </div>
    </a>
  );
};


export const InfoIcon = ({ tooltip, tipId }) => (
<>
  <svg
    data-tip={tooltip}
    data-for={tipId}
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    style={{ cursor: 'pointer' }}
    title = 'this is tooltip'
    >
    <path
    d="M10.1725 7H10.1823M9.19033 10H10.1725V14H11.1547M1.33276 10C1.33276 11.1819 1.56141 12.3522 2.00565 13.4442C2.44989 14.5361 3.10102 15.5282 3.92187 16.364C4.74272 17.1997 5.71721 17.8626 6.7897 18.3149C7.86219 18.7672 9.01167 19 10.1725 19C11.3334 19 12.4829 18.7672 13.5554 18.3149C14.6278 17.8626 15.6023 17.1997 16.4232 16.364C17.244 15.5282 17.8952 14.5361 18.3394 13.4442C18.7836 12.3522 19.0123 11.1819 19.0123 10C19.0123 7.61305 18.081 5.32387 16.4232 3.63604C14.7654 1.94821 12.517 1 10.1725 1C7.82808 1 5.57965 1.94821 3.92187 3.63604C2.26409 5.32387 1.33276 7.61305 1.33276 10Z"
    stroke="#354052"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    />
  </svg>
  <ReactTooltip
    id={tipId}
    place="bottom"
    variant="info"
    className="tooltip-lg"
    >
    </ReactTooltip>
  </>
);

 const PercentageBadge = ({ percentage, title }) => {
  if (percentage == null) return null;

  const isNumber = typeof percentage === "number";
  const isPositive = isNumber && percentage > 0;
  const isNegative = isNumber && percentage < 0;
  const isZero = isNumber && percentage === 0;
  const toolTip_content = !isNumber
  ? 'No prior period of equal length to compare.'
  : '% change compared to the previous period of equal length.';  const textColor = isNegative ? "#F83B3B" : "#239636";
  const backgroundColor = isNegative ? '#FFC7C7' : "#C0F2C8"


  const badgeClass = isPositive || isZero || !isNumber
    ? "success-light-green_bg"
    : "danger-light-red";

  const strokeColor = "#239636";

  const ArrowIcon = !isNumber ? (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="6" viewBox="0 0 14 6" fill="none">
      <path d="M1 3H13" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ) : isNegative ? (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
      <path d="M1 0.666748L5 4.66675L7.66667 2.00008L13 7.33341M13 7.33341H8.33333M13 7.33341V2.66675" stroke="#dc3545" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ) : isPositive ? (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
      <path d="M1 7.33341L5 3.33341L7.66667 6.00008L13 0.666748M13 0.666748H8.33333M13 0.666748V5.33341" stroke={strokeColor} strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ) : null;

  return (
    <>
      <span
        className={`badge badge-pill ${badgeClass} mr-1 d-flex align-items-center `}
        data-tip = {toolTip_content}
        data-for={title}
      >
        {ArrowIcon}
        <span className="ml-1">
          {isNumber ? `${Math.abs(percentage).toLocaleString('en-US')}%` : "%"}
        </span>
      </span>

      <ReactTooltip
        id={title}
        place="bottom"
        effect="solid"
        className="tooltip-sm"
        backgroundColor={backgroundColor}
        textColor={textColor}
      >
      </ReactTooltip>
    </>
  );
};

const SideStats = ({live_campaigns, roi}) => (
  <div className="card right-card p-3 rounded-3">
    <StatItem title="Active Events" tooltip="The number of upcoming events during the selected time period that used at least one of Vasta's paid marketing channels. Events that were created, but not promoted with a paid marketing channel do not show up in this count." total={live_campaigns.total} percentageChange={live_campaigns.percentage_change} />
    <hr />
    <StatItem title="Return on Investment" tooltip="An estimate of your return on investment calculated by taking your estimated number of ticket sales plus the estimated number of hours saved at $15/hour, divided by your total spend on marketing with Vesta during that time period." total={`${roi.total}x`} percentageChange={roi.percentage_change} />
  </div>
);

const StatItem = ({ title, tooltip, total, percentageChange }) => {
  return (
    <div>
      <div className="d-flex justify-content-between">
        <h3>{title}</h3>
        <InfoIcon tooltip={tooltip} tipId="campaign" />
      </div>
      <h2>{total ?? 'N/A'}</h2>
      {percentageChange != null && (
        <div>
          <PercentageBadge percentage={percentageChange}  title={title}/>
          <span>vs. Previous Period</span>
        </div>
      )}
    </div>
  );
};

export default PerformancePage;